import { Entity } from "@jobilla/entity";

export class BrandingSettings extends Entity {
  color = "#710ce2";
}
